export default {
    home: {
        coreCapabilities: {
            name: '核心能力',
            title0: '研發創新',
            description0: '持續投入研發,推動醫藥技術創新',
            title1: '品質保證',
            description1: '嚴格的品質管制體系,確保產品安全可靠',
            title2: '全球佈局',
            description2: '國際化戰略,拓展全球市場',
        },
        profile: {
            title: '公司簡介',
            subtitle: '瞭解永濤',
        },
        companyProfile: {
            name: '公司簡介',
            specialtyName: '我們的專長',
            teamName: '我們的團隊',
            missionName: '我們的使命',
            layoutName: '全國佈局',
            expertise: '將成熟的藥品引進中國,將有競爭力的優質原料藥推廣到全球',
            team: '由醫學、藥學博士、律師、醫生和企業高管組成',
            mission: '推動有影響力的醫療保健解決方案',
            offices: {
                city0: '南通', type0: '總部（中國）',
                city1: '香港', type1: '總部（全球）',
                city2: '杭州', type2: '辦事處',
                city3: '重慶', type3: '辦事處',
                city4: '上海', type4: '辦事處',
                city5: '合肥', type5: '辦事處'
            }
        },
        companyStats: {
            name: '公司概況',
            title0: '年收入',
            value0: '26億元',
            description0: '2023年實現的強勁收入',
            title1: '利潤率',
            value1: '8%',
            description1: '穩健的財務表現',
            title2: '專業團隊',
            value2: '485+',
            description2: '敬業的醫藥專家'
        },
        strategicGoals: {
            name: '戰略目標',
            year0: '2027',
            target0: '每年3種新品',
            description0: '成為最高效的新產品推出公司',
            year1: '2028',
            target1: '1億美元',
            description1: '實現專業製藥公司價值目標',
            year2: '2030',
            target2: '5億美元',
            description2: '成為行業領軍企業'
        },
        regions: {
            title: '永濤製藥辦公系統（OA）',
            formLabel0: "請選擇區域",
            placeholder0: "請選擇登入區域",
            formLabel1: "員工工號",
            placeholder1: "請輸入員工工號",
            formLabel2: "登入密碼",
            placeholder2: "請輸入登入密碼",
            buttonName: '登入',
            errorMsg: '請填寫完整的登入資訊',
            errorNames: ['無此帳號', '密碼與帳號不符'],
            label0: '中國大陸', value0: 'mainland',
            label1: '港澳臺', value1: 'gat',
            label2: '歐洲', value2: 'europe',
            label3: '北美', value3: 'north_america',
            label4: '南美', value4: 'south_america',
            label5: '非洲', value5: 'africa',
            label6: '東亞', value6: 'east_asia',
            label7: '南亞', value7: 'south_asia',
            label8: '中亞', value8: 'central_asia',
            label9: '西亞', value9: 'west_asia'
        },
        productCategories: {
            name: '產品類別',
            name0: '神经系统药品',
            name1: '心血管药品',
            name2: '消化代谢药品',
            name3: '呼吸系统药品',
        },
        researchAreas: {
            title: '研發領域',
            name0: '神經病學與心血管',
            description0: '專注於神經系統疾病和心血管健康的創新治療方案',
            projects0: ['美托洛爾', '腦血管病變研究'],
            name1: '腫瘤學',
            description1: '開發創新的抗癌藥物和治療方案',
            projects1: ['苯紮魯胺', '靶向治療'],
            name2: '消化與呼吸系統',
            description2: '研發消化系統和呼吸系統疾病的治療藥物',
            projects2: ['消化酶研究', '呼吸道治療'],
        },
        complianceTraining: {
            title: '合規培訓',
            categories: {
                title: '培訓類別',
                list: [
                    '新員工入職培訓（每季度）',
                    '年會（以年為組織）',
                    '業務部門會議（不定期）-供應鏈培訓（不定期）',
                    '線上培訓（不定期）'
                ]
            },
            content: {
                title: '培訓內容',
                list: [
                    '合規性準則和系統',
                    '合規行為和符合文化規範-報帳政策',
                    '不良反應監測報告',
                    '反腐敗和商業商業賄賂'
                ]
            },
            vision: {
                title: '培訓的願景',
                list: [
                    '基於培訓的考試',
                    '檢查結果標記'
                ]
            },
            update: {
                title: '內容更新',
                list: [
                    '每年更新一次',
                    '基於最新版本的RDPAC要求-基於合作夥伴的法規遵從性系統要求',
                    '基於內部和外部的稽核結果'
                ]
            }
        },
    },
    menu: {
        home: '首頁',
        resources: '藥品資源',
        news: '新闻中心',
        about: '關於我們',
        contact: '聯繫我們'
    },
    hero: {
        title: '永濤製藥',
        subtitle: '開創中國專業醫藥行業的新時代',
        description: '永濤是一家一流的專業製藥公司,以其向中國市場交付創新產品的卓越效率,為行業樹立新的標杆',
        learnMore: '瞭解更多',
        oaSystem: '員工辦公系統（OA）'
    },
    sections: {
        capabilities: '核心能力',
        research: '研發領域',
        profile: '公司簡介',
        products: '產品類別',
        goals: '戰略目標',
        overview: '公司概況',
        compliance: '合規培訓'
    },
    oa: {
        title: '永濤製藥辦公系統（OA）',
        region: '請選擇區域',
        employeeId: '員工工號',
        password: '登入密碼',
        login: '登入',
        errors: {
            incomplete: '請填寫完整的登入資訊',
            noAccount: '無此帳號',
            wrongPassword: '密碼與帳號不符'
        }
    },
    about: {
        title: '關於永濤',
        subtitle: '製藥和化工行業的新興領導者',
        company: {
            title: '公司簡介',
            description: '永濤是製藥和化工行業的新興領導者,具有戰畧定位,總部位於中國南通。 我們在全國設有辦事處,包括杭州、滁州、香港和拉萨。 永濤於2022年由經驗豐富的製藥高管和財務實力雄厚的投資者創立,結合敏捷與專業,形成動態可靠的合作夥伴關係。'
        },
        mission: {
            title: '我們的使命',
            description: '培育和綜合經過驗證的醫藥產品進入中國市場,確保它們與中國的獨特需求和標準相一致,同時培育一個强大的合作夥伴關係網絡。'
        },
        strategicGoals: {
            title: '戰略目標',
            goals: {
                goal2028: {
                    title: '2028年目標',
                    description: '成為一家價值1億美元的專業製藥公司,通過投資研發促進創新,加强與醫療保健機构的合作夥伴關係,以及加强市場滲透戰畧。'
                },
                goal2030: {
                    title: '2030年願景',
                    description: '轉型為一家價值5億美元的公司,專注於擴大運營規模和提高運營效率,簡化製造流程,利用新興技術優勢進行成本效益生產。'
                },
                innovation: {
                    title: '產品創新',
                    description: '從2027年開始,成為最有效的新產品推出公司,每年推出三種專業的新產品,通過持續投資前沿研究和培養跨職能合作來實現。'
                }
            }
        },
        capabilities: {
            title: '核心能力',
            items: {
                innovation: {
                    title: '研發創新',
                    description: '積極參與國內研發工作,致力於創造創新的、本地定制的藥品,通過與領先研究機構的戰略合作,保持在中國開發有影響力的醫療保健解決方案的前沿。'
                },
                collaboration: {
                    title: '全球合作',
                    description: '作為外國公司進入中國市場的首選合作夥伴,提供高效的產品注册和盈利的市場策略。 我們的專業團隊確保所有產品無縫和合法地進入市場。'
                },
                network: {
                    title: '戰畧網絡',
                    description: '通過在全國各地的戰畧辦事處網絡,包括南通、杭州、重慶、香港、上海和合肥,我們能够以卓越的專業性和敏捷性滿足不同的項目需求。'
                }
            }
        }
    },
    contact: {
        companyName: '香港永濤藥業有限公司',
        address: '香港旺角花園街2-16號好景商業中心16樓4室',
        phone: '+86 18651110588',
        email: 'hao.xiaofeng@yongtao-hk.com',
        logoAlt: '永濤製藥',
        mapTitle: '香港永濤藥業有限公司'
    },
    products: {
        title: '產品中心',
        subtitle: '永濤製藥致力於為患者提供優質可靠的醫藥產品',
        categories: {
            neurological: {
                name: '神經系統',
                products: {
                    flunarizine: {
                        name: '鹽酸氟桂利嗪膠囊',
                        description: '用於偏頭痛和血管性頭痛的預防和治療'
                    },
                    levodopa: {
                        name: '左旋多巴和苯拉嗪片',
                        description: '用於帕金森氏症的治療'
                    }
                }
            },
            cardiovascular: {
                name: '心血管系統',
                products: {
                    metoprolol: {
                        name: '酒石酸美托洛爾片',
                        description: '用於高血壓、心絞痛等心血管疾病的治療'
                    },
                    sacubitril: {
                        name: '沙庫比利和纈沙坦鈉片',
                        description: '用於慢性心力衰竭的治療'
                    }
                }
            },
            antiviral: {
                name: '抗病毒及腫瘤',
                products: {
                    peramivir: {
                        name: '帕拉米韋注射液',
                        description: '用於流感病毒感染的治療'
                    },
                    enzalutamide: {
                        name: '恩紮魯胺軟膠囊',
                        description: '用於前列腺癌的治療'
                    }
                }
            }
        }
    },
    resources: {
        title: '藥品資源中心',
        subtitle: '創新醫藥解決方案的領導者',
        categories: {
            neurological: {
                name: '神經系統用藥',
                products: {
                    flunarizine: {
                        name: '鹽酸氟桂利嗪膠囊',
                        description: '用於偏頭痛和眩暈的預防性治療,改善腦部血液迴圈'
                    },
                    levodopa: {
                        name: '左旋多巴和苯拉嗪片',
                        description: '帕金森氏症的治療藥物,改善運動功能'
                    }
                }
            },
            cardiovascular: {
                name: '心血管系統用藥',
                products: {
                    metoprolol: {
                        name: '酒石酸美托洛爾片',
                        description: '用於高血壓、心絞痛和心律失常的治療'
                    },
                    sacubitril: {
                        name: '沙庫比曲和纈沙坦鈉片',
                        description: '用於慢性心力衰竭的創新治療方案'
                    }
                }
            },
            antitumor: {
                name: '抗腫瘤藥物',
                products: {
                    enzalutamide: {
                        name: '恩紮魯胺軟膠囊',
                        description: '用於轉移性去勢抵抗性前列腺癌的治療'
                    }
                }
            }
        },
        tags: {
            migraine: '偏頭痛',
            dizziness: '眩暈',
            prescription: '處方藥',
            parkinsons: '帕金森',
            movement_disorder: '運動障礙',
            hypertension: '高血壓',
            angina: '心絞痛',
            heart_failure: '心衰',
            innovative: '創新藥',
            tumor: '腫瘤'
        }
    },
    footer: {
        contact: {
            title: '聯繫我們',
            phone: '+86 18651110588',
            email: 'hao.xiaofeng@yongtao-hk.com ',
            address: '香港旺角花園街2-16號好景商業中心16樓4室'
        },
        quickLinks: {
            title: '快速連結',
            resources: '藥品資源',
            about: '關於我們',
            contact: '聯繫我們'
        },
        social: {
            title: '關注我們'
        },
        copyright: '香港永濤藥業有限公司版權所有'
    }
}